import ApiService from '@/services/core/api.service'

const DashboardService = {
  async getStatistics () {
    return ApiService.get('senior-mechanic/dashboard/statistics')
  }
}

export default DashboardService
